/**
 * Thin client for Spenderly Pro API (auth, billing, push).
 */
const DEFAULT_BASE = '';

export function apiBase() {
  const raw = process.env.REACT_APP_API_URL || DEFAULT_BASE;
  if (!raw) return '';
  return raw.replace(/\/$/, '');
}

export function apiConfigured() {
  return Boolean(apiBase());
}

export async function apiFetch(path, { method = 'GET', body, token, headers } = {}) {
  const base = apiBase();
  if (!base) {
    throw new Error('API URL not configured (set REACT_APP_API_URL)');
  }
  const url = path.startsWith('http') ? path : `${base}${path.startsWith('/') ? path : `/${path}`}`;
  const res = await fetch(url, {
    method,
    headers: {
      ...(body ? { 'Content-Type': 'application/json' } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...headers,
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  let data = null;
  const text = await res.text();
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = { raw: text };
  }
  if (!res.ok) {
    const err = new Error(data?.error || res.statusText || 'Request failed');
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}
